"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("./styles/color"));
var _Text = _interopRequireDefault(require("../SharedComponents/Typography/Text"));
var _Button = _interopRequireDefault(require("./Buttons/Button"));
var _Icon = _interopRequireDefault(require("./Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
// $FlowFixMe

/* istanbul ignore next */
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-s9cg6x-0"
})(["display:flex;flex-wrap:nowrap;flex-direction:column;align-items:center;border:1px solid ", ";width:100%;"], function (props) {
  return props.active ? _color["default"].success : _color["default"].lightGrey;
});
Container.displayName = 'Container';

/* istanbul ignore next */
var Body = _styledComponents["default"].div.withConfig({
  displayName: "Body",
  componentId: "sc-s9cg6x-1"
})(["display:flex;flex-wrap:nowrap;flex-direction:row;align-items:center;height:95px;border-bottom:1px solid ", ";background-color:", ";padding-left:27px;padding-right:16px;width:100%;"], _color["default"].lightestGrey, function (props) {
  return props.active ? 'rgba(10, 189, 99, 0.05)' : _color["default"].lightPrimary;
});
Body.displayName = 'Body';
var Footer = _styledComponents["default"].div.withConfig({
  displayName: "Footer",
  componentId: "sc-s9cg6x-2"
})(["display:flex;flex-wrap:nowrap;flex-direction:row;background-color:", ";width:100%;height:49px;"], _color["default"].white);
Footer.displayName = 'Footer';
/* istanbul ignore next */
var Logo = _styledComponents["default"].div.withConfig({
  displayName: "Logo",
  componentId: "sc-s9cg6x-3"
})(["display:flex;align-items:center;padding-top:8px;padding-bottom:8px;width:50px;justify-content:center;"]);
Logo.displayName = 'Logo';
var Input = _styledComponents["default"].input.withConfig({
  displayName: "Input",
  componentId: "sc-s9cg6x-4"
})(["width:90%;background:transparent;@media (max-width:370px){width:80%;}border:none;cursor:pointer;padding:0 10px 0 10px;outline:none;font-size:16px;font-family:Raleway;font-style:normal;font-weight:400;font-size:16px;&:focus{border:none;outline:none;&::-webkit-input-placeholder{color:transparent;-webkit-transition:color 0.2s ease;transition:color 0.2s ease;}&:-moz-placeholder{color:transparent;-webkit-transition:color 0.2s ease;transition:color 0.2s ease;}&::-moz-placeholder{color:transparent;-webkit-transition:color 0.2s ease;transition:color 0.2s ease;}&:-ms-input-placeholder{color:transparent;-webkit-transition:color 0.2s ease;transition:color 0.2s ease;}}"]);
Input.displayName = 'Input';
/* istanbul ignore next */
var ToggleContainer = _styledComponents["default"].div.withConfig({
  displayName: "ToggleContainer",
  componentId: "sc-s9cg6x-5"
})(["display:flex;flex-direction:row;padding-right:16px;"]);
ToggleContainer.displayName = 'ToggleContainer';
var Title = _styledComponents["default"].div.withConfig({
  displayName: "Title",
  componentId: "sc-s9cg6x-6"
})(["display:flex;width:100%;padding-left:21px;flex-direction:row;justify-content:space-between;align-items:center;"]);
Title.displayName = 'Title';
var ToggleLabel = _styledComponents["default"].div.withConfig({
  displayName: "ToggleLabel",
  componentId: "sc-s9cg6x-7"
})(["display:flex;@media (max-width:375px){display:none;}"]);
ToggleLabel.displayName = 'ToggleLabel';
var Data = _styledComponents["default"].div.withConfig({
  displayName: "Data",
  componentId: "sc-s9cg6x-8"
})(["display:flex;width:200px;padding-left:21px;flex-direction:row;justify-content:space-between;align-items:center;margin-right:10px;@media (max-width:450px){width:150px;}"]);
Data.displayName = 'Data';
var FooterContainer = _styledComponents["default"].div.withConfig({
  displayName: "FooterContainer",
  componentId: "sc-s9cg6x-9"
})(["display:flex;padding-left:15px;flex-direction:row;align-items:center;flex:1;"]);
FooterContainer.displayName = 'FooterContainer';
var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-s9cg6x-10"
})(["margin-left:8px;margin-right:8px;z-index:2;"]);
IconContainer.displayName = 'IconContainer';
var Info = _styledComponents["default"].div.withConfig({
  displayName: "Info",
  componentId: "sc-s9cg6x-11"
})(["margin-left:8px;margin-right:8px;z-index:2;@media (max-width:414px){display:none;}"]);
Info.displayName = 'Info';
var InputContainer = _styledComponents["default"].div.withConfig({
  displayName: "InputContainer",
  componentId: "sc-s9cg6x-12"
})(["display:flex;flex-direction:row;flex:2;align-items:center;position:relative;border:1px solid ", ";padding:8px 0 8px 14px;align-content:end;background-color:", ";cursor:pointer;width:auto;"], _color["default"].lightGrey, _color["default"].white);
InputContainer.displayName = 'InputContainer';
/* istanbul ignore next */
var ActiveState = _styledComponents["default"].div.withConfig({
  displayName: "ActiveState",
  componentId: "sc-s9cg6x-13"
})(["display:flex;flex-direction:row-reverse;justify-content:space-between;align-items:center;margin-right:10px;height:49px;", " padding-right:6px;"], function (props) {
  return props.fullWidth ? 'width: 100%;' : '';
});
ActiveState.displayName = 'ActiveState';
var ButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "ButtonContainer",
  componentId: "sc-s9cg6x-14"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;z-index:2;"]);
ButtonContainer.displayName = 'ButtonContainer';
function ServiceCard(props) {
  var icon = props.icon,
    title = props.title,
    toggle = props.toggle,
    toggleLabel = props.toggleLabel,
    active = props.active,
    activeLabel = props.activeLabel,
    dataLabel = props.dataLabel,
    onChange = props.onChange;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(props.data),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  (0, _react.useEffect)(function () {
    return setData(props.data);
  }, [props.data]);
  var openInput = function openInput() {
    setOpen(true);
  };
  var onCancel = function onCancel() {
    setOpen(false);
    setData(props.data);
  };
  var onSave = function onSave() {
    setOpen(false);
    onChange(data || '');
  };
  var footer;
  if (!open) {
    var activeFooter;
    if (active) {
      activeFooter = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Data, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        text: data || '',
        textSize: "p",
        fontColor: _color["default"].info,
        ellipsis: true
      })), /*#__PURE__*/_react["default"].createElement(ButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        icon: "pen",
        onClick: openInput
      })));
    }
    footer = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, activeFooter, /*#__PURE__*/_react["default"].createElement(ActiveState, {
      fullWidth: true
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      text: activeLabel,
      textSize: "p",
      fontColor: active ? _color["default"].success : _color["default"].lightGrey,
      align: "right"
    })));
  } else {
    footer = /*#__PURE__*/_react["default"].createElement(FooterContainer, null, /*#__PURE__*/_react["default"].createElement(Info, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      text: dataLabel,
      textSize: "p",
      fontColor: _color["default"].darkGray,
      ellipsis: true
    })), /*#__PURE__*/_react["default"].createElement(Info, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      color: _color["default"].darkGray,
      iconName: "info",
      size: "x"
    })), /*#__PURE__*/_react["default"].createElement(InputContainer, null, /*#__PURE__*/_react["default"].createElement(Input, {
      onChange: function onChange(e) {
        return setData(e.currentTarget.value);
      },
      value: data
    })), /*#__PURE__*/_react["default"].createElement(ActiveState, null, /*#__PURE__*/_react["default"].createElement(IconContainer, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      icon: "check",
      style: "success",
      fill: true,
      onClick: onSave
    })), /*#__PURE__*/_react["default"].createElement(IconContainer, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      icon: "x",
      style: "error",
      outline: true,
      onClick: onCancel
    }))));
  }
  return /*#__PURE__*/_react["default"].createElement(Container, {
    active: active
  }, /*#__PURE__*/_react["default"].createElement(Body, {
    active: active
  }, /*#__PURE__*/_react["default"].createElement(Logo, null, icon), /*#__PURE__*/_react["default"].createElement(Title, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    text: title,
    textSize: "p",
    fontColor: _color["default"].darkestGray
  })), /*#__PURE__*/_react["default"].createElement(ToggleContainer, null, toggle), /*#__PURE__*/_react["default"].createElement(ToggleLabel, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    text: toggleLabel,
    textSize: "p",
    fontColor: _color["default"].darkestGray,
    align: "right"
  }))), /*#__PURE__*/_react["default"].createElement(Footer, null, footer));
}
__signature__(ServiceCard, "useState{[open, setOpen](false)}\nuseState{[data, setData](props.data)}\nuseEffect{}");
var _default = ServiceCard;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(Container, "Container", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(Body, "Body", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(Footer, "Footer", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(Logo, "Logo", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(Input, "Input", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(ToggleContainer, "ToggleContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(Title, "Title", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(ToggleLabel, "ToggleLabel", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(Data, "Data", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(FooterContainer, "FooterContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(IconContainer, "IconContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(Info, "Info", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(InputContainer, "InputContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(ActiveState, "ActiveState", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(ButtonContainer, "ButtonContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(ServiceCard, "ServiceCard", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/ServiceCard.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();